import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home, Camera, Monitor, Play, Users, Shield, Settings, Clock } from 'lucide-react'

const BreadcrumbNavigation = ({ customBreadcrumbs = null }) => {
    const location = useLocation()

    const getIcon = (path) => {
        switch (path) {
            case 'dashboard':
                return <Home className="h-4 w-4" />
            case 'cameras':
                return <Camera className="h-4 w-4" />
            case 'camera-monitoring':
                return <Monitor className="h-4 w-4" />
            case 'camera-playback':
                return <Clock className="h-4 w-4" />
            case 'users':
                return <Users className="h-4 w-4" />
            case 'roles':
                return <Shield className="h-4 w-4" />
            case 'profile':
                return <Settings className="h-4 w-4" />
            default:
                return null
        }
    }

    const getLabel = (path) => {
        switch (path) {
            case 'dashboard':
                return 'Dashboard'
            case 'cameras':
                return 'Camera Management'
            case 'camera-monitoring':
                return 'Live Monitoring'
            case 'camera-playback':
                return 'Playback'
            case 'users':
                return 'User Management'
            case 'roles':
                return 'Role Management'
            case 'profile':
                return 'Profile Settings'
            default:
                return path.charAt(0).toUpperCase() + path.slice(1).replace('-', ' ')
        }
    }

    // Use custom breadcrumbs if provided, otherwise generate from current path
    const breadcrumbs = customBreadcrumbs || (() => {
        const pathSegments = location.pathname.split('/').filter(Boolean)
        
        if (pathSegments.length === 0) {
            return [{ path: 'dashboard', label: 'Dashboard', href: '/dashboard' }]
        }

        return pathSegments.map((segment, index) => {
            const href = '/' + pathSegments.slice(0, index + 1).join('/')
            return {
                path: segment,
                label: getLabel(segment),
                href: href,
                isLast: index === pathSegments.length - 1
            }
        })
    })()

    return (
        <nav 
            aria-label="Breadcrumb" 
            className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400"
        >
            <ol className="flex items-center space-x-2">
                {breadcrumbs.map((crumb, index) => (
                    <li key={crumb.path} className="flex items-center">
                        {index > 0 && (
                            <ChevronRight className="h-4 w-4 mx-2 text-gray-400" />
                        )}
                        
                        {crumb.isLast ? (
                            <span 
                                className="flex items-center space-x-1 text-gray-900 dark:text-gray-100 font-medium"
                                aria-current="page"
                            >
                                {getIcon(crumb.path)}
                                <span>{crumb.label}</span>
                            </span>
                        ) : (
                            <Link
                                to={crumb.href}
                                className="flex items-center space-x-1 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded px-1 py-0.5"
                            >
                                {getIcon(crumb.path)}
                                <span>{crumb.label}</span>
                            </Link>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    )
}

export default BreadcrumbNavigation